import { render, staticRenderFns } from "./OrderSale.vue?vue&type=template&id=73ae2535&scoped=true&"
import script from "./OrderSale.vue?vue&type=script&lang=js&"
export * from "./OrderSale.vue?vue&type=script&lang=js&"
import style0 from "./OrderSale.vue?vue&type=style&index=0&id=73ae2535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae2535",
  null
  
)

export default component.exports